import { createContext, useState, useContext, useEffect } from "react";

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Force light theme only
    setTheme("light");
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (isInitialized) {
      // Always ensure dark class is removed to force light theme
      document.documentElement.classList.remove("dark");
    }
  }, [isInitialized]);

  const toggleTheme = () => {
    // Disabled - always keep light theme
    // setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
